import { ParaTag } from "@tm/static";
import { theme } from "@tm/utility/global";
import React, { useState } from "react";
import FormattedText, {
  getPlainText,
  TextNodeType,
} from "../../FormattedText/FormattedText";
import {
  CriteriaLabelRow,
  InfoButton,
  InfoIconImg,
  NewIcon,
  TooltipContainer,
  TooltipText,
} from "./FilterPlans.style";

const DEFAULT_INFO_ICON = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="8" cy="8" r="6.4" stroke="#757575"/>
  <path d="M8.67 7.32v4.41c0 .37-.3.67-.67.67s-.67-.3-.67-.67V7.32c0-.37.3-.67.67-.67s.67.3.67.67z" fill="#757575"/>
  <circle cx="8" cy="5.17" r="0.87" fill="#757575"/>
</svg>`;

interface FilterCriteriaLabelProps {
  label?: string | TextNodeType;
  newIcon?: string;
  infoIcon?: string;
  popover?: {
    description?: {
      text?: { value?: string };
    };
  };
}

const FilterCriteriaLabel = ({
  label,
  newIcon,
  infoIcon,
  popover,
}: FilterCriteriaLabelProps) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipDescription = popover?.description;
  const hasTooltip = !!tooltipDescription?.text?.value;
  const showInfoIcon = !!infoIcon || hasTooltip;
  const plainLabel =
    typeof label === "string" ? label : getPlainText(label);

  const stopInputToggle = (event: React.MouseEvent | React.KeyboardEvent) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <CriteriaLabelRow>
      <ParaTag fontSize="sm" color={theme.blackText} margin="0">
        <FormattedText value={label} />
      </ParaTag>
      {newIcon ? <NewIcon src={newIcon} alt="new" /> : null}
      {showInfoIcon ? (
        <InfoButton
          type="button"
          aria-label={`Info about ${plainLabel}`}
          onMouseDown={stopInputToggle}
          onClick={(event) => {
            stopInputToggle(event);
            if (hasTooltip) {
              setShowTooltip((visible) => !visible);
            }
          }}
          onMouseEnter={() => {
            if (hasTooltip) setShowTooltip(true);
          }}
          onMouseLeave={() => {
            if (hasTooltip) setShowTooltip(false);
          }}
        >
          {infoIcon ? (
            <InfoIconImg src={infoIcon} alt="" />
          ) : (
            <span
              aria-hidden
              dangerouslySetInnerHTML={{ __html: DEFAULT_INFO_ICON }}
            />
          )}
          {showTooltip && hasTooltip ? (
            <TooltipContainer
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
            >
              <TooltipText>
                <FormattedText value={tooltipDescription} />
              </TooltipText>
            </TooltipContainer>
          ) : null}
        </InfoButton>
      ) : null}
    </CriteriaLabelRow>
  );
};

export default FilterCriteriaLabel;
